export const SET_IS_LOGGED = 'SET_IS_LOGGED'
export const SET_PROFILE_NAME = 'SET_PROFILE_NAME'
export const SET_IS_SPINNING = 'SET_IS_SPINNING'
